<template>
  <div class="content1 col-xs-12 col-sm-12 col-md-3 m-b-sm-15">
    <div class="m-r-15 background-c-fff raduis-3">
      <div id="side_menu" class="content1_padding">
        <div class="h_title m-b-15 m-l-15 visible-md-block visible-lg-block">会员中心</div>
        <div class="b_cont side_menu m-l-15">
          <a href="javascript:;" id="side_menu_btn" :style="{'background-color': $store.state.color}" class="visible-xs-block visible-sm-block raduis-3">个人中心<i class="xybicon"></i></a>
          <ul class="visible-md-block visible-lg-block ul_1">
            <li :class="[$route.name === item.aName ? 'active_bg' : '']" v-for="item in list" v-if="item.show">
              <a :href="'#/' + item.path"
              :style="{ 'color': $route.name === item.aName ? $store.state.color : '' }"
              @mouseover="over($event)" @mouseout="out($event, item)">{{item.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      list: [
        {name: '个人中心', path: '', aName: 'index', show: true},
        {name: '我的订单', path: 'order', aName: 'order', show: true},
        {name: '我的收藏', path: 'favorite', aName: 'favorite', show: true},
        {name: '我的积分', path: 'point', aName: 'point', show: true},
        {name: '优惠券', path: 'gain', aName: 'gain', show: true},
        {name: '收货地址', path: 'address', aName: 'address', show: true},
        {name: '个人信息', path: 'info', aName: 'info', show: true}
      ]
    }
  },
  mounted () {
    this.getNav()
  },
  computed: {
    ...mapState(['hidePanel'])
  },
  watch: {
    hidePanel: {
      handler () {
        this.getNav()
      }
    }
  },
  methods: {
    getNav () {
      this.list.filter((item) => {
        this.hidePanel.forEach(element => {
          if (item.aName === element) {
            item.show = false
          }
        })
      })
    },
    over (e) {
      e.target.style.color = this.$store.state.color
    },
    out (e, item) {
      if (this.$route.name !== item.aName) {
        e.target.style.color = null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue